import React, { useState } from 'react';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { HarmonizationResultCard } from './harmonization-result-card';
import { harmonizationMessages } from './messages';
import styles from './styles.module.less';

/**
 * @param {{
 *   suggestions: Array<import('./harmonization-api').HarmonizationSuggestion>,
 *   onCodeClick: (code: string) => void,
 *   onClear: () => void
 * }} props
 * @returns {React.ReactElement}
 */
export const HarmonizationResults = ({ suggestions, onCodeClick, onClear }) => {
  const [selectedCode, setSelectedCode] = useState(null);

  const handleCardClick = (code) => {
    setSelectedCode(code);
    onCodeClick(code);
  };

  if (suggestions.length === 0) {
    return <Text className={styles.resultsContainer} textType={TextType.Paragraph} value={harmonizationMessages.noSuggestionsAvailable} />;
  }

  return (
    <div className={styles.resultsContainer}>
      <div className={styles.resultsHeader}>
        <Text textType={TextType.H4} value={harmonizationMessages.aiSuggestedCodes} />
        <Button onClick={onClear} theme={THEME_CONSTANTS.link}>
          <Text value={harmonizationMessages.clear} />
        </Button>
      </div>
      {suggestions.map((suggestion) => (
        <HarmonizationResultCard
          key={suggestion.suggestedCode}
          code={suggestion.suggestedCode}
          confidence={suggestion.confidenceLevel}
          isSelected={selectedCode === suggestion.suggestedCode}
          onClick={() => handleCardClick(suggestion.suggestedCode)}
          reasoning={suggestion.reasoning}
          referenceChapter={suggestion.referenceChapter}
        />
      ))}
    </div>
  );
};
